import { render, staticRenderFns } from "./copyLiveRoom.vue.js?vue&type=template&id=2b518f8c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./copyLiveRoom.vue?vue&type=template&id=2b518f8c&scoped=true"
import script from "./copyLiveRoom.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./copyLiveRoom.vue?vue&type=script&lang=js"
export * from "./copyLiveRoom.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./copyLiveRoom.vue?vue&type=script&lang=js"
import style0 from "./copyLiveRoom.vue.scss?vue&type=style&index=0&id=2b518f8c&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./copyLiveRoom.vue?vue&type=style&index=0&id=2b518f8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b518f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b518f8c')) {
      api.createRecord('2b518f8c', component.options)
    } else {
      api.reload('2b518f8c', component.options)
    }
    module.hot.accept("./copyLiveRoom.vue.js?vue&type=template&id=2b518f8c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./copyLiveRoom.vue?vue&type=template&id=2b518f8c&scoped=true", function () {
      api.rerender('2b518f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/copyLiveRoom.vue"
export default component.exports